exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-richiedi-visita-large[data-v-9d1759c4] {\n  position: relative;\n}\n.btn-richiedi-visita-large .svg-icon[data-v-9d1759c4] {\n  position: absolute;\n  left: 15px;\n  fill: white;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n.btn-richiedi-visita-large .svg-icon svg[data-v-9d1759c4] {\n  height: 24px;\n  width: 24px;\n}", ""]);

// exports
